import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

/**
 * Enregistre une action utilisateur dans Firestore
 */
export const logUserAction = async (
  userEmail: string,
  actionType: string,
  target: string
) => {
  try {
    await addDoc(collection(db, "UserLogs"), {
      user: userEmail,
      type: actionType,
      target: target,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de l'action utilisateur:", error);
  }
};

/**
 * Enregistre une action administrateur dans Firestore
 */
export const logAdminAction = async (
  adminEmail: string,
  actionType: string,
  target: string
) => {
  try {
    await addDoc(collection(db, "AdminLogs"), {
      admin: adminEmail,
      type: actionType,
      target: target,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de l'action admin:", error);
  }
}; 